module.exports = __webpack_public_path__ + "static/media/plus--white.b65e9169.svg";